export { default } from './PageMantri';
